import { useQuery } from '@tanstack/react-query';

import { Membership } from 'src/features/membership/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    membershipId: string;
}
const queryFn = ({ parkingId, membershipId }: DTO): Promise<Membership> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_MEMBERSHIP_RESOURCE, useQueryHook as useGetMembership };
